import React from "react";
import { BREAKPOINTS } from "../../../config/breakpoints";
import { chunkArrayInGroups } from "../../../utils/utils";
import { HOME_PAGE_FOOTER_LINKS } from "../../../config/footer_contents";
import { Translation } from "react-i18next";
import { TFunction } from "i18next";
import ResizableComponent from "../../resizable_component/resizable_component";
import app_store_badge from "../../../assets/badges/app_store_badge.png";
import google_play_badge from "../../../assets/badges/google-play-badge.png";

import "./home_page_footer.scss";

class HomePageDesktopFooter extends ResizableComponent {

    render() {
        let width = this.state.windowWidth;

        let maxColumns = 8;
        let showContactsAsCol = true;
        let oneColumnForStores = false;
        if (width < BREAKPOINTS.MD) {
            maxColumns = 3;
            showContactsAsCol = false;
            oneColumnForStores = true;
        } else if (width < BREAKPOINTS.LG) {
            maxColumns = 5;
            showContactsAsCol = false;
            oneColumnForStores = true;
        } else if (width < BREAKPOINTS.XL) {
            maxColumns = 6;
            showContactsAsCol = false;
        } else if (width < BREAKPOINTS.XXL) {
            maxColumns = 8;
            oneColumnForStores = true;
        }

        let arraySize = Math.max(2, Math.ceil(HOME_PAGE_FOOTER_LINKS.length / maxColumns));

        let contents = chunkArrayInGroups(HOME_PAGE_FOOTER_LINKS, arraySize);

        return (
            <div className="home-page-footer home-page-overlay">
                <div className="links-row">
                    {showContactsAsCol &&
                        <div className="links-column" key="footer-col-contacts">
                            <p className="home-page-footer-text">
                                © {(new Date().getFullYear())} Luiss Guido Carli
                            </p>
                            <p className="home-page-footer-text">
                                Viale Pola 12, 00198 Roma, Italia
                            </p>
                            <p className="home-page-footer-text">
                                Centralino T 06 852251 - P.IVA 01067231009
                            </p>
                        </div>
                    }
                    <Translation>
                        {(t: TFunction) => contents.map((col, colIndex) =>
                            <div className="links-column" key={`footer-col-${colIndex}`}>
                                {col.map((link, linkIndex) =>
                                    <a className="home-page-footer-link" href={t(`FOOTER link ${link} url`)} key={`footer-link-${linkIndex}-${link}`}>
                                        {t(`FOOTER link ${link} label`)}
                                    </a>
                                )}
                            </div>
                        )}
                    </Translation>
                    {oneColumnForStores ?
                        <div className="links-column" key={`footer-col-stores`}>
                            <a href="https://apps.apple.com/it/app/luiss/id1039424016">
                                <img src={app_store_badge} alt="Download-on-the-App-Store" className="store" />
                            </a>
                            <a href="https://play.google.com/store/apps/details?id=it.luiss.tsc">
                                <img src={google_play_badge} alt="Google-Play" className="store" />
                            </a>
                        </div>
                        :
                        <>
                            <div className="store-column" key={`footer-col-appstore`}>
                                <a href="https://apps.apple.com/it/app/luiss/id1039424016">
                                    <img src={app_store_badge} alt="Download-on-the-App-Store" className="store" />
                                </a>
                            </div>
                            <div className="store-column" key={`footer-col-googleplay`}>
                                <a href="https://play.google.com/store/apps/details?id=it.luiss.tsc">
                                    <img src={google_play_badge} alt="Google-Play" className="store" />
                                </a>
                            </div>
                        </>
                    }
                </div>
                {!showContactsAsCol &&
                    <div className="contacts-row home-page-footer-text">
                        © {(new Date().getFullYear())} Luiss Guido Carli - Viale Pola 12, 00198 Roma, Italia - Centralino T 06 852251 - P.IVA 01067231009
                    </div>
                }
            </div>
        );
    }
}

export default HomePageDesktopFooter;